<template>
  <content-container :loadingStatus="isLoading" style="min-width: 905px">
    <div class="special-offer-list content-wrapper">
      <div class="page-header">{{ $t('specialOffer') }}</div>
      <div>
        <el-row>
          <el-col :span="24">
            <special-offer-create-button-component
              :hotel-list="hotelList"
              @onCreateSpecialOffer="onCreateSpecialOffer">
            </special-offer-create-button-component>
          </el-col>
        </el-row>
        <special-offer-search-component
          :hotel-list="hotelList"
          :agent-list="agentList"
          :promotion-list="promotionList"
          :market-list="marketList"
          :sale-person-list="salePersonList"
          @onSearchButtonClick="onSearchButtonClick"
          @onResetButtonClick="onResetButtonClick">
        </special-offer-search-component>
        <div>
          <div style="margin-top: -10px; margin-bottom: 10px">
            <span style="margin-right: 10px">Record per pages</span>
            <el-select v-model="itemPerPage" placeholder="Select" @change="onItemPerPageChange">
              <el-option
                v-for="item in pageSizeOptions"
                :key="`item-per-page-${item.label}`"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="margin-bottom: 25px">
            <ul class="ul-table" v-for="(specialOffer, index) of specialOfferList" :key="`special-offer-${index}`"
                :class="getRowClassName(specialOffer)">
              <li style="margin-bottom: 20px">
                <div style="display: table; width: 100%">
                  <div class="inline-block" style="min-width: 115px">
                    <div>
                      <el-dropdown>
                        <el-button :type="getStatusType(specialOffer.status)" size="mini" style="padding: 10px 15px">
                          {{ getStatusName(specialOffer.status) }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="onChangeStatus(specialOffer.id, SPECIAL_OFFER_STATUS.DRAFT)">
                            {{ $t('draft') }}
                          </el-dropdown-item>
                          <el-dropdown-item
                            @click.native="onChangeStatus(specialOffer.id, SPECIAL_OFFER_STATUS.PUBLISHED)">
                            {{ $t('published') }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="inline-block" :class="getTextClassName(specialOffer)" style="max-width: 65%">
                    <div class="border-special-offer-ref-code" :title="specialOffer.refCode">
                      {{ specialOffer.refCode }}/<span class="helping-tag"
                                                       style="margin-left: 3px; text-transform: uppercase">{{
                        $t('agentName')
                      }}</span>
                    </div>
                  </div>
                  <div class="inline-block" :class="getTextClassName(specialOffer)">
                    <div v-if="isShowInternalNote(specialOffer)" style="line-height: 34px">
                      <el-popover :placement="'right'" width="400" trigger="click" style="padding: 0 !important;">
                        <div class="internal-note-popover-header el-card__header">
                          <span>{{ $t('internalNote') }}</span>
                        </div>
                        <div class="internal-note-popover-body">
                          {{ specialOffer.internalNote }}
                        </div>
                        <i class="el-icon-info btn-icon-note" slot="reference"></i>
                      </el-popover>
                    </div>
                  </div>
                  <div class="inline-block" style="float: right;" :class="getTextClassName(specialOffer)">
                    <div class="label-special-offer-row" style="text-align: right;">
                      <div style="text-align: right;  display: inline-flex; margin-right: 15px;">{{
                          $t('issueDate')
                        }}
                      </div>
                      <div style=" display: inline-flex;">{{ getDateText(specialOffer.issueDate, 'short') }}</div>
                    </div>
                    <div class="label-special-offer-row" style="text-align: right;">
                      <div style="text-align: right; display: inline-flex; margin-right: 15px;">{{
                          $t('lastUpdate')
                        }}
                      </div>
                      <div style=" display: inline-flex;">{{ getDateText(specialOffer.updatedAt) }}</div>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="getTextClassName(specialOffer)">
                <div style="display: table; width: 100%">
                  <div class="row-table">
                    <div class="form-special-offer-data">
                      <div class="label-special-offer-row">{{ $t('hotel') }}</div>
                      <div class="data-special-offer-row" :title="getHotelName(specialOffer.hotelId)">
                        {{ getHotelName(specialOffer.hotelId) }}
                      </div>
                    </div>
                  </div>
                  <div class="row-table" style="width: 15%">
                    <div class="form-special-offer-data">
                      <div class="label-special-offer-row">{{ $t('promotion') }}</div>
                      <div class="data-special-offer-row" :title="getPromotionCode(specialOffer)">
                        <popover-special-offer-promotion-detail
                          v-if="hasPromotionCode(specialOffer)"
                          :special-offer-id="specialOffer.id"
                          :promotion-id="specialOffer.promotionId"
                          :promotion-code="specialOffer.promotionCode"
                          :hotel-id="specialOffer.hotelId">
                        </popover-special-offer-promotion-detail>
                        <span v-else>-</span>
                      </div>
                    </div>
                  </div>
                  <div class="row-table" style="width: 23%">
                    <div class="form-special-offer-data" style="white-space: nowrap">
                      <div class="label-special-offer-row">{{ $t('specialOfferValid') }}</div>
                      <div class="data-special-offer-row" :title="getValidPeriod(specialOffer)">
                        {{ getValidPeriod(specialOffer) }}
                      </div>
                    </div>
                  </div>
                  <div class="row-table" style="width: 15%">
                    <div class="form-special-offer-data">
                      <div class="label-special-offer-row">{{ $t('salesPerson') }}</div>
                      <div class="data-special-offer-row" :title="getSalePersonName(specialOffer)">
                        {{ getSalePersonName(specialOffer) }}
                      </div>
                    </div>
                  </div>
                  <div class="row-table" style="width: 12%">
                    <div class="form-special-offer-data">
                      <div class="label-special-offer-row">{{ $t('totalAgents') }}</div>
                      <div class="data-special-offer-row" :title="specialOffer.agentIdList.length">
                        <el-tag
                          style="cursor: pointer"
                          @click="onPopupAgentListButtonClick(specialOffer)">
                          {{ specialOffer.agentIdList.length }} {{ $t('agents') }}
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  <div class="row-table" style="float: right; width: 15%">
                    <div style="text-align: right; white-space: nowrap;">
                      <div style="float: right">
                        <el-button
                          plain
                          style="border-radius: 4px 0 0 4px; padding: 10px 20px"
                          type="primary"
                          @click="onEditButtonClick(specialOffer)">
                          {{ $t('edit') }}
                        </el-button>
                        <el-dropdown>
                          <el-button type="primary"
                                     style="padding: 10px 5px 10px 0; border-radius: 0px 4px 4px 0; margin-left: -1px;"
                                     plain>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </el-button>
                          <el-dropdown-menu slot="dropdown" class="action-list">
                            <el-dropdown-item @click.native="onPreviewButtonClick(specialOffer)">
                              {{ $t('preview') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="onDuplicateButtonClick(specialOffer.id)">
                              {{ $t('duplicate') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="onTotalSignedDocumentClick(specialOffer.id)">
                              {{ $t('signedDocument') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="onDeleteButtonClick(specialOffer)" class="text-error">
                              {{ $t('delete') }}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                      <div v-if="getTotalSignedDocument(specialOffer) > 0"
                           style="float: right; margin-right: 10px; margin-top: 10px; cursor: pointer"
                           @click="onTotalSignedDocumentClick(specialOffer.id)">
                        <div class="font-primary"
                             style="float: left; font-size: 13px; margin-right: 3px; font-weight: 600">
                          {{ getTotalSignedDocument(specialOffer) }}
                        </div>
                        <div class="signed-document-primary"
                             style="float: left; margin-top: 3px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div style="margin-top: 10px">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="itemPerPage"
              :current-page="currentPage"
              @current-change="onPageChange"
              :total="totalListLength">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <popup-special-offer-agent-list-component
      :visible="isShowPopupAgentList"
      :agent-list="agentList"
      :ref-code="refCode"
      :promotion-code="promotionCode"
      :special-offer-id="showPopupAgentListSpecialOfferId"
      @onClose="onClosePopupAgentList"
      @onPreview="onPreviewSpecialOfferByAgent"
      @onDownload="onDownloadSpecialOfferByAgent"
      @onSendEmail="onSendEmailSpecialOfferByAgent">
    </popup-special-offer-agent-list-component>
    <preview-special-offer-by-agent-component
      :visible="isShowPreviewByAgent"
      :special-offer-detail="previewSpecialOfferDetail"
      :selected-agent="previewWithAgent"
      :hotel="previewHotel"
      :room-type-list="previewRoomTypeList"
      @onClose="isShowPreviewByAgent = false"
      @onDownload="onDownloadSpecialOfferByAgentFromPreview"
    ></preview-special-offer-by-agent-component>
    <popup-send-email-component
      :title="$t('sendEmailSpecialOffers')"
      :visible="isPopupSendEmailVisible"
      :init-data="initEmailData"
      :send-type="EMAIL_SEND_TYPE.SPECIAL_OFFER"
      :ref-code="previewSpecialOfferDetail.refCode"
      :agent="previewWithAgent"
      @onClose="isPopupSendEmailVisible = false">
    </popup-send-email-component>
    <preview-special-offer-component
      :visible="isShowPreview"
      :special-offer-detail="previewSpecialOfferDetail"
      :hotel="previewHotel"
      :room-type-list="previewRoomTypeList"
      @onClose="isShowPreview = false"
      @onSaveDraft="isShowPreview = false"
      @onSavePublish="onPreviewSpecialOfferSavePublish"
    ></preview-special-offer-component>
    <popup-signed-document-list
      :visible="isShowPopupSignedDocumentList"
      :special-offer-id="showPopupSignedDocumentSpecialOfferId"
      @onClose="isShowPopupSignedDocumentList = false"
      @onUploaded="onUploadedSignedDocument">
    </popup-signed-document-list>
  </content-container>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'

import {
  SPECIAL_OFFER_STATUS,
  SPECIAL_OFFER_REF_CODE_TYPE,
  VUEX_EVENT,
  STATUS,
  DOCUMENT_TYPE,
  EMAIL_SEND_TYPE
} from '@/configs/constant'
import SpecialOfferCreateButtonComponent from './components/SpecialOfferCreateButtonComponent'
import PopoverSpecialOfferPromotionDetail from './components/PopoverSpecialOfferPromotionDetailComponent'
import PopupSpecialOfferAgentListComponent from '@/views/SpecialOffer/components/PopupSpecialOfferAgentListComponent'
import SpecialOfferSearchComponent from '@/views/SpecialOffer/components/SpecialOfferSearchComponent'
import PreviewSpecialOfferByAgentComponent from './components/PreviewSpecialOfferByAgentComponent'
import PreviewSpecialOfferComponent from './components/ManageSpecialOffer/PreviewSpecialOfferComponent'
import PopupSignedDocumentList from './components/PopupSignedDocumentList'
import PopupSendEmailComponent from '@/components/PopupSendEmailComponent'
import SpecialOfferApi from '@/api/special-offer-api'
import { getDuplicateSpecialOfferDetail, prepareDocumentData } from '@/services/special-offer-service'
import { forceDownloadFileUrl, delay, filterDisableList } from '@/helpers'
import _, { get } from 'lodash'
import { mapState } from 'vuex'
import AgentService from '@/services/agent-service'
import { getSpecialOfferFileName } from '@/domains/special-offer-domain'
import { dateFormat } from '@/helpers/datetime'
import { getHotelInfo } from '@/services/hotel-service'

export default {
  name: 'SpecialOfferList',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: {
    SpecialOfferSearchComponent,
    ContentContainer,
    SpecialOfferCreateButtonComponent,
    PopoverSpecialOfferPromotionDetail,
    PopupSpecialOfferAgentListComponent,
    PreviewSpecialOfferByAgentComponent,
    PopupSendEmailComponent,
    PreviewSpecialOfferComponent,
    PopupSignedDocumentList
  },
  i18n: { messages: i18nMessages },
  computed: {
    ...mapState({
      specialOfferSearchCriteria: state => state.specialOffer.specialOfferSearchCriteria,
      specialOfferListCurrentPage: state => state.specialOffer.specialOfferListCurrentPage,
      specialOfferListLastId: state => state.specialOffer.specialOfferListLastId,
      specialOfferPageListStore: state => state.specialOffer.specialOfferPageListStore
    })
  },
  data () {
    return {
      EMAIL_SEND_TYPE,
      SPECIAL_OFFER_STATUS,
      isLoading: false,
      moreItem: true,
      specialOfferList: [],
      specialOfferPageList: {},
      currentPage: 1,
      maxPage: 2,
      hotelList: [],
      salePersonList: [],
      agentList: [],
      agentIdList: [],
      promotionList: [],
      marketList: [],
      refCode: '',
      promotionCode: '',
      isShowPopupAgentList: false,
      disabledNext: false,
      disabledPrevious: true,
      isShowPopupSignedDocumentList: false,
      showPopupSignedDocumentSpecialOfferId: '',
      showPopupAgentListSpecialOfferId: '',
      filter: {
        refCode: '',
        agentId: '',
        hotelId: '',
        promotionId: '',
        specialOfferValid: '',
        agentIdList: [],
        salePersonId: '',
        validBookingDate: '',
        issueStartDate: '',
        issueEndDate: '',
        status: ''
      },
      isFirstLoad: true,
      lastId: '',
      currentPreviewAgent: {},
      isShowPreview: false,
      isShowPreviewByAgent: false,
      previewSpecialOfferId: '',
      previewWithAgent: {
        name: '',
        information: {
          address: '',
          country: '',
          emailList: [],
          faxList: [],
          phoneList: [],
          zipCode: ''
        },
        contactPerson: {
          emailList: [],
          firstName: '',
          lastName: '',
          title: '',
          position: ''
        }
      },
      previewHotel: {},
      previewSpecialOfferDetail: {
        autoRefCode: STATUS.DISABLE,
        status: SPECIAL_OFFER_STATUS.DRAFT,
        refCode: '',
        refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
        hotel: {
          id: '',
          information: {
            code: '',
            name: ''
          },
          salePerson: {
            id: '',
            title: '',
            firstName: '',
            lastName: '',
            position: '',
            email: '',
            updatedAt: ''
          }
        },
        promotion: {
          promotion: {
            id: '',
            code: '',
            detail: '',
            minNight: 0,
            maxNight: 0,
            isEnable: 0,
            updatedAt: 0,
            bookingPeriod: {
              startDate: '',
              endDate: ''
            },
            periodOfStayList: [],
            isEnableAllotment: 0,
            roomTypeList: []
          }
        },
        agentList: [],
        general: {
          startDate: '',
          endDate: '',
          issueDate: '',
          internalNote: '',
          footerMessage: '',
          bodyMessage: ''
        }
      },
      previewRoomTypeList: [],
      isPopupSendEmailVisible: false,
      initEmailData: {
        senderName: '',
        senderNameList: [],
        replyEmail: '',
        toEmailList: [],
        ccEmailList: [],
        bccEmailList: [],
        attachmentList: []
      },
      itemPerPage: 10,
      pageSizeOptions: [{
        value: 10,
        label: '10'
      }, {
        value: 20,
        label: '20'
      }, {
        value: 50,
        label: '50'
      }, {
        value: 100,
        label: '100'
      }, {
        value: 999,
        label: 'All'
      }],
      totalListLength: 1
    }
  },
  created: async function () {
    await this.initData()
  },
  methods: {
    initData: async function () {
      this.isLoading = true
      this.filter = Object.assign(this.filter, this.specialOfferSearchCriteria)
      const filter = {
        filter: this.filter,
        isFirstLoad: this.isFirstLoad,
        lastId: (this.specialOfferListCurrentPage > 1) ? this.specialOfferListLastId : '',
        length: this.specialOfferList.length * (this.currentPage - 1),
        limitItem: this.itemPerPage
      }

      const result = await Promise.all([
        AgentService.getAgentList(),
        SpecialOfferApi.list(filter)
      ])
      this.agentList = result[0]
      const specialOfferListResponse = result[1]

      this.specialOfferList = specialOfferListResponse.specialOfferList
      this.totalListLength = specialOfferListResponse.count
      this.pageSizeOptions[4].value = specialOfferListResponse.count
      this.moreItem = specialOfferListResponse.moreItem
      this.hotelList = specialOfferListResponse.hotelList
      this.salePersonList = specialOfferListResponse.salePersonList
      this.promotionList = filterDisableList(specialOfferListResponse.promotionList)
      this.marketList = specialOfferListResponse.marketList
      this.companyData = specialOfferListResponse.companyData

      const specialOfferListLength = specialOfferListResponse.specialOfferList.length
      if (specialOfferListLength > 0) {
        this.lastId = specialOfferListResponse.specialOfferList[specialOfferListLength - 1].id
      }

      const sortedSpecialOfferList = this._sortSpecialOfferList(specialOfferListResponse.specialOfferList)

      this.specialOfferList = [...sortedSpecialOfferList]
      this.specialOfferPageList[this.currentPage] = [...sortedSpecialOfferList]

      if (this.specialOfferListCurrentPage > 1) {
        this.currentPage = this.specialOfferListCurrentPage

        this.specialOfferPageList = Object.assign(this.specialOfferPageList, this.specialOfferPageListStore)
        this.specialOfferList = [...this.specialOfferPageList[this.currentPage]]

        this.lastId = this.specialOfferList[this.specialOfferList.length - 1].id
      }

      this.maxPage = (specialOfferListResponse.moreItem) ? this.currentPage + 1 : this.currentPage
      this._setDisableNextPreviousButton()
      this.isLoading = false
    },
    getSpecialOfferList: async function (isShowLoading = true) {
      if (isShowLoading === true) {
        this.startLoading()
      }

      try {
        const filter = {
          filter: this.filter,
          lastId: this.lastId,
          isFirstLoad: false
        }

        const specialOfferListResponse = await SpecialOfferApi.list(filter)
        this.totalListLength = specialOfferListResponse.count
        const specialOfferListLength = specialOfferListResponse.specialOfferList.length
        this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.SET_SPECIAL_OFFER_LIST_LAST_ID, this.lastId)

        if (specialOfferListLength > 0) {
          this.lastId = specialOfferListResponse.specialOfferList[specialOfferListLength - 1].id
          const sortedSpecialOfferList = this._sortSpecialOfferList(specialOfferListResponse.specialOfferList)

          this.specialOfferList = [...sortedSpecialOfferList]
          this.specialOfferPageList[this.currentPage] = [...sortedSpecialOfferList]
        } else {
          this.specialOfferList = []
        }

        this.maxPage = (specialOfferListResponse.moreItem) ? this.currentPage + 1 : this.currentPage
        this._setDisableNextPreviousButton()
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    _sortSpecialOfferList: function (specialOfferList) {
      const sortedSpecialOfferList = specialOfferList.sort((prev, next) => {
        return (prev.id > next.id) ? -1 : 1
      })

      return sortedSpecialOfferList
    },
    getRowClassName: function (specialOffer) {
      return (specialOffer.status === SPECIAL_OFFER_STATUS.DRAFT) ? 'bg-special-offer-draft' : ''
    },
    getTextClassName: function (specialOffer) {
      return (specialOffer.status === SPECIAL_OFFER_STATUS.DRAFT) ? 'text-special-offer-draft' : ''
    },
    isShowInternalNote: function (specialOffer) {
      const internalNote = get(specialOffer, 'internalNote', '')
      return (internalNote.trim() !== '')
    },
    getStatusType: function (status) {
      return (status === SPECIAL_OFFER_STATUS.PUBLISHED) ? 'success' : 'info'
    },
    getStatusName: function (status) {
      let statusName = ''

      switch (status) {
        case SPECIAL_OFFER_STATUS.DRAFT:
          statusName = this.$t('draft')
          break
        case SPECIAL_OFFER_STATUS.PUBLISHED:
          statusName = this.$t('published')
          break
        default:
          statusName = 'N/A'
          break
      }

      return statusName
    },
    getPromotionCode: function (specialOfferItem) {
      const promotionCode = get(specialOfferItem, 'promotionCode', '-')

      return promotionCode
    },
    getHotelName: function (hotelId) {
      const hotelData = this.hotelList.find(hotel => hotel.id === hotelId)
      const hotelName = get(hotelData, 'name', '-')

      return hotelName
    },
    getValidPeriod: function (specialOfferData) {
      let specialOfferValid = '-'
      const filterData = _.omitBy(specialOfferData, _.isNull)
      const specialOfferStart = get(filterData, 'startDate', undefined)
      const specialOfferEnd = get(filterData, 'endDate', undefined)

      if (specialOfferStart !== undefined && specialOfferEnd !== undefined) {
        const startDate = new Date(specialOfferStart)
        const endDate = new Date(specialOfferEnd)

        specialOfferValid = `${dateFormat.short(startDate)} - ${dateFormat.short(endDate)}`
      }

      return specialOfferValid
    },
    getDateText: function (dateData, dateType = 'long') {
      const date = new Date(dateData)
      const time = date.getTime()

      if (isNaN(time)) {
        return '-'
      }

      if (dateData === null) {
        return '-'
      }

      const textDate = (dateType === 'long') ? dateFormat.long(date) : dateFormat.short(date)

      return textDate
    },
    onEditButtonClick: function (row) {
      const hotelData = this.hotelList.find(hotel => hotel.id === row.hotelId)
      const promotionList = _getPromotionListByHotelId(row.hotelId, this.promotionList)

      return this.$router.push({
        name: 'SpecialOfferEdit',
        params: {
          specialOfferId: row.id,
          hotel: hotelData,
          promotionList: promotionList,
          agentList: this.agentList,
          salePersonList: this.salePersonList,
          isShowFromAgent: this.isShowFromAgent
        }
      })
    },
    getAgentName: function (specialOfferItem) {
      const agentName = get(specialOfferItem, 'agentName', '-')

      return agentName
    },
    getSalePersonName: function (specialOfferItem) {
      const salePersonName = get(specialOfferItem, 'salePersonName', '')

      return (salePersonName.trim() === '') ? '-' : salePersonName.trim()
    },
    onCreateSpecialOffer: function (hotelId) {
      const hotelData = this.hotelList.find(hotel => hotel.id === hotelId)
      const promotionList = _getPromotionListByHotelId(hotelId, this.promotionList)

      return this.$router.push({
        name: 'SpecialOfferAdd',
        params: {
          hotel: hotelData,
          promotionList: promotionList
        }
      })
    },
    onPopupAgentListButtonClick: function (specialOfferItem) {
      this.showPopupAgentListSpecialOfferId = specialOfferItem.id
      this.refCode = specialOfferItem.refCode
      this.promotionCode = get(specialOfferItem, 'promotionCode', '-')
      this.agentIdList = specialOfferItem.agentIdList

      this.previewSpecialOfferId = specialOfferItem.id
      this.previewHotel = this.hotelList.find(item => item.id === specialOfferItem.hotelId)

      this.isShowPopupAgentList = true
    },
    onItemPerPageChange: function () {
      this.currentPage = 1
      this.initData()
    },
    onClosePopupAgentList: function () {
      this.refCode = ''
      this.promotionCode = ''
      this.agentIdList = []

      this.isShowPopupAgentList = false
    },
    onChangeStatus: async function (specialOfferId, status) {
      this.startLoading()
      try {
        await this._updateStatus(specialOfferId, status)
        const notificationTitle = this.$t('updateSpecialOfferStatusSuccess')
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err)
      }
      this.stopLoading()
    },
    onPageChange: function (page) {
      this.currentPage = page
      this.initData()
    },
    onDuplicateButtonClick: async function (specialOfferId) {
      try {
        this.startLoading()

        const duplicatedSpecialOfferDetail = await getDuplicateSpecialOfferDetail(specialOfferId)
        const hotelData = this.hotelList.find(hotel => hotel.id === duplicatedSpecialOfferDetail.hotel.id)
        const promotionList = _getPromotionListByHotelId(duplicatedSpecialOfferDetail.hotel.id, this.promotionList)

        this.$router.push({
          name: 'SpecialOfferAdd',
          params: {
            duplicatedSpecialOfferDetail: duplicatedSpecialOfferDetail,
            hotel: hotelData,
            promotionList: promotionList,
            isDuplicate: true
          }
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    _setDisableNextPreviousButton: function () {
      this.disabledNext = (this.currentPage === this.maxPage)
      this.disabledPrevious = (this.currentPage === 1)
    },
    onDeleteButtonClick: async function (specialOffer) {
      const confirmMessage = this.$t('confirmDeleteSpecialOfferMessage', {
        refCode: specialOffer.refCode
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)
      if (!isConfirmRemove) {
        return false
      }
      this.removeSpecialOffer(specialOffer.id)
    },
    removeSpecialOffer: async function (specialOfferId) {
      try {
        await SpecialOfferApi.remove(specialOfferId)
        this.specialOfferList = this.specialOfferList.filter(item => item.id !== specialOfferId)
      } catch (err) {
        this.alertError(err.message)
      }
    },
    onSearchButtonClick: async function (filter) {
      this.filter = Object.assign({}, filter)
      this.lastId = ''
      this.specialOfferPageList = {}
      this.currentPage = 1
      await this.getSpecialOfferList()
    },
    onResetButtonClick: async function (filter) {
      this.filter = Object.assign({}, filter)
      this.lastId = ''
      this.specialOfferPageList = {}
      this.currentPage = 1
      await this.getSpecialOfferList()
    },
    onPreviewSpecialOfferByAgent: async function (selectAgentId) {
      this.startLoading()
      try {
        await this._getSpecialOfferDetail(selectAgentId)
      } catch (err) {
        this.alertError(err)
      }
      this.stopLoading()
      this.isShowPreviewByAgent = true
    },
    onPreviewButtonClick: async function (specialOfferItem) {
      this.startLoading()
      try {
        this.previewHotel = this.hotelList.find(item => item.id === specialOfferItem.hotelId)
        this.previewSpecialOfferId = specialOfferItem.id
        await this._getSpecialOfferDetail()
      } catch (err) {
        this.alertError(err)
      }
      this.stopLoading()
      this.isShowPreview = true
    },
    onDownloadSpecialOfferByAgent: async function (selectAgentId) {
      this.startLoading()
      try {
        await this._getSpecialOfferDetail(selectAgentId)
        await delay(1500)
        await this._downloadSpecialOffer()
      } catch (err) {
        this.alertError(err)
      }
      this.stopLoading()
    },
    onDownloadSpecialOfferByAgentFromPreview: async function () {
      this.isShowPreviewByAgent = false
      this.startLoading()
      try {
        await this._downloadSpecialOffer()
      } catch (err) {
        this.alertError(err)
      }
      this.stopLoading()
    },
    _downloadSpecialOffer: async function () {
      const data = prepareDocumentData(this.previewSpecialOfferDetail, this.previewWithAgent)
      const documentResult = await SpecialOfferApi.generateDocument(this.previewSpecialOfferDetail.id, data, DOCUMENT_TYPE)
      const documentData = `data:${DOCUMENT_TYPE}; base64, ${documentResult}`
      const fileName = getSpecialOfferFileName(data.refCode)
      forceDownloadFileUrl(documentData, fileName)
    },
    onSendEmailSpecialOfferByAgent: async function (selectAgentId) {
      this.startLoading()
      try {
        await this._prepareInitEmail(selectAgentId)
      } catch (err) {
        this.alertError(err)
      }
      this.stopLoading()
      this.isPopupSendEmailVisible = true
    },
    onPreviewSpecialOfferSavePublish: async function () {
      this.startLoading()
      try {
        await this._updateStatus(this.previewSpecialOfferId, SPECIAL_OFFER_STATUS.PUBLISHED)
        const notificationTitle = this.$t('updateSpecialOfferStatusSuccess')
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err)
      }
      this.isShowPreview = false
      this.stopLoading()
    },
    getTotalSignedDocument: (specialOffer) => {
      const totalSignedDocument = get(specialOffer, 'totalSignedDocument', 0)

      return totalSignedDocument
    },
    onTotalSignedDocumentClick: function (specialOfferId) {
      this._showPopupSignedDocumentList(specialOfferId)
    },
    onSignedDocumentClick: function (specialOfferId) {
      this._showPopupSignedDocumentList(specialOfferId)
    },
    onUploadedSignedDocument: function (specialOfferId) {
      const specialOffer = this.specialOfferList.find(item => item.id === specialOfferId)
      if (specialOffer.id === specialOfferId) {
        if (specialOffer.totalSignedDocument === undefined) {
          specialOffer.totalSignedDocument = 0
        }

        specialOffer.totalSignedDocument += 1
      }
    },
    _showPopupSignedDocumentList: function (specialOfferId) {
      this.isShowPopupSignedDocumentList = true
      this.showPopupSignedDocumentSpecialOfferId = specialOfferId
    },
    _getSpecialOfferDetail: async function (selectAgentId = '') {
      try {
        const specialOfferResult = await SpecialOfferApi.detail(this.previewSpecialOfferId)
        this._initSpecialOfferDetail(specialOfferResult.specialOfferDetail, specialOfferResult.roomTypeList)

        if (selectAgentId !== '') {
          const agentList = get(this.previewSpecialOfferDetail, 'agentList', [])
          this.previewWithAgent = agentList.find(item => item.id === selectAgentId)
        }
        this.previewRoomTypeList = specialOfferResult.roomTypeList
      } catch (err) {
        throw err
      }
    },
    _initSpecialOfferDetail: function (specialOfferDetail, roomTypeList) {
      const specialOfferPromotion = get(specialOfferDetail, 'promotion', {})
      const specialOfferRoomTypeList = get(specialOfferPromotion, 'roomTypeList', [])
      const appliedRoomTypeNameList = specialOfferRoomTypeList.map(specialOfferRoomType => {
        const roomTypeSourceData = roomTypeList.find(roomTypeSource => roomTypeSource.id === specialOfferRoomType.id)
        const roomTypeSourceName = get(roomTypeSourceData, 'name', '')
        const specialOfferRoomTypeName = get(specialOfferRoomType, 'name', '')

        const newRoomTypeName = {
          name: (!specialOfferRoomTypeName) ? roomTypeSourceName : specialOfferRoomTypeName
        }
        const newRoomType = Object.assign({}, specialOfferRoomType, newRoomTypeName)

        return newRoomType
      })

      const newRoomTypeList = {
        roomTypeList: appliedRoomTypeNameList
      }
      const newPromotion = Object.assign({}, specialOfferPromotion, newRoomTypeList)
      const newSpecialOfferPromotion = {
        promotion: newPromotion
      }
      this.previewSpecialOfferDetail = Object.assign({}, specialOfferDetail, newSpecialOfferPromotion)
    },
    _prepareInitEmail: async function (selectAgentId) {
      const hotel = this.previewHotel
      const hotelData = await getHotelInfo(hotel.id)
      await this._getSpecialOfferDetail(selectAgentId)
      const contactPersonEmailList = get(this.previewWithAgent, 'contactPerson.emailList', [])

      const ccEmailList = get(hotelData, 'emailConfiguration.ccEmailList', [])
      const bccEmailList = get(hotelData, 'emailConfiguration.bccEmailList', [])

      const senderList = this._prepareSenderList()
      await delay(1500)
      const attachment = await this._prepareAttachmentData()

      this.initEmailData = {
        hotelId: hotelData.id,
        senderList: senderList,
        toEmailList: contactPersonEmailList,
        ccEmailList: ccEmailList,
        bccEmailList: bccEmailList,
        attachmentList: [attachment]
      }
    },
    _prepareSenderList: function () {
      const senderList = this.hotelList.map((hotel) => {
        const hotelName = get(hotel, 'name', '')
        const emailSenderName = get(hotel, 'senderName', '')
        const replyEmail = get(hotel, 'replyEmail', '')
        const senderName = (emailSenderName === '') ? hotelName : emailSenderName

        const result = {
          hotelId: hotel.id,
          name: senderName,
          hotelName: hotelName,
          replyEmail: replyEmail
        }

        return result
      })

      senderList.sort((pre, next) => {
        return (pre.name > next.name) ? 1 : -1
      })

      return senderList
    },
    _prepareAttachmentData: async function () {
      const data = prepareDocumentData(this.previewSpecialOfferDetail, this.previewWithAgent)
      const fileName = getSpecialOfferFileName(data.refCode)
      const documentResult = await SpecialOfferApi.generateDocument(this.previewSpecialOfferDetail.id, data, DOCUMENT_TYPE)

      const attachment = {
        type: DOCUMENT_TYPE,
        name: fileName,
        content: documentResult
      }

      return attachment
    },
    _updateStatus: async function (specialOfferId, status) {
      const data = {
        id: specialOfferId,
        status: status
      }
      await SpecialOfferApi.updateStatus(data)
      this.specialOfferList = this.specialOfferList.map((item) => {
        if (item.id === specialOfferId) {
          item.status = status
        }
        return item
      })
    },
    hasPromotionCode: function (specialOffer) {
      const promotionCode = get(specialOffer, 'promotionCode', '')

      return (promotionCode !== '')
    }
  }
}

function _getPromotionListByHotelId (hotelId, allPromotionList) {
  const promotionList = allPromotionList.filter(promotion => promotion.hotelId === hotelId)

  return promotionList
}
</script>

<style scoped>
#special-offer-list-table {
  width: 100%;
  border: 1px solid #dddddd;
  border-radius: 5px;
  box-shadow: 0px 3px 5px 1px #eeeeee;
}

.ul-table {
  margin: 0;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-right: 1px solid #ddd;
  padding: 10px;
}

.ul-table > li {
  list-style: none;
  margin: 10px;
}

.ul-table:last-child {
  border-bottom: 1px solid #ddd;
}

.row-table {
  display: inline-block;
  width: 20%;
  vertical-align: top;
}

.inline-block {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}

.form-special-offer-data {
  padding: 0 10px;
}

.border-special-offer-ref-code {
  background-color: #ecf5ff;
  color: #2f7dfe;
  padding: 6px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
}

.btn-icon-note {
  font-size: 22px;
  position: relative;
  top: 3px;
  padding: 0 5px;
  color: #909399;
  cursor: pointer;
}

.internal-note-popover-header {
  padding: 10px;
  border-bottom: 1px solid #EBEEF5;
  font-size: 15px;
  background-color: #f8f9fa;
}

.internal-note-popover-body {
  padding: 10px;
}

.label-special-offer-row {
  font-size: 12px;
  color: #909399;
  font-weight: 600;
}

.data-special-offer-row {
  font-size: 14px;
  color: #666666;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bg-special-offer-draft {
  background-color: #f5f7fa;
}

.text-special-offer-draft {
  opacity: 0.5;
}

.el-button {
  text-align: left;
}

.el-button--info .el-icon--right {
  margin-left: 32px;
}

.el-button--success .el-icon--right {
  /*margin-left: 11px;*/
}

.text-error {
  color: #F56C6C;
}

.el-dropdown-menu {
  padding: 0;
}

.action-list .el-dropdown-menu__item.text-error {
  color: #F56C6C;
}

.action-list .el-dropdown-menu__item {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
  border-bottom: 1px #fff solid;
  padding: 0 70px 0 20px;
}

.action-list .el-dropdown-menu__item:hover {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
}

.action-list .el-dropdown-menu__item:last-of-type {
  border-bottom: 0;
}

.el-button--success {
  color: #FFF;
  background-color: #48c195;
  border-color: #48c195;
}

.el-button--success:focus, .el-button--success:hover {
  background: #5adaac;
  border-color: #5adaac;
  color: #FFF;
}

.el-tag.el-tag--warning {
  font-weight: bold !important;
  border-color: #e6a23c !important;
}

.helping-tag {
  background-color: #2f7dfe;
  color: #ffffff;
  padding: 3px 5px;
  border-radius: 15px;
  font-size: 10px;
  vertical-align: bottom;
}
</style>
